import { requestRecaptcha as request } from '@/config/ConfigRequest';
import ENDPOINT from '@/config/endpoint';

function login(data, recaptchaToken) {
  return request({
    url: ENDPOINT.LOGIN,
    method: 'post',
    data,
  }, recaptchaToken);
}

export default {
  login,
};
